import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      icon: 'TrendingUp',
      label: 'Média de Avaliação',
      value: stats?.averageRating?.toFixed(1),
      suffix: '/5.0',
      color: 'primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'Eye',
      label: 'Total de Visualizações',
      value: stats?.totalViews?.toLocaleString('pt-BR'),
      suffix: '',
      color: 'secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      icon: 'ThumbsUp',
      label: 'Total de Curtidas',
      value: stats?.totalLikes?.toLocaleString('pt-BR'),
      suffix: '',
      color: 'accent',
      bgColor: 'bg-accent/10'
    },
    {
      icon: 'Award',
      label: 'Conteúdos em Destaque',
      value: stats?.featuredCount,
      suffix: '',
      color: 'primary',
      bgColor: 'bg-primary/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg p-4 md:p-6 transition-smooth hover:glow-primary-hover"
        >
          <div className="flex items-start justify-between mb-3 md:mb-4">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-md ${stat?.bgColor} flex items-center justify-center glow-${stat?.color}`}>
              <Icon name={stat?.icon} size={20} color={`var(--color-${stat?.color})`} />
            </div>
          </div>
          
          <div className="space-y-1">
            <p className="text-xs md:text-sm text-muted-foreground">
              {stat?.label}
            </p>
            <div className="flex items-baseline gap-1">
              <span className={`text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-${stat?.color}`}>
                {stat?.value}
              </span>
              {stat?.suffix && (
                <span className="text-sm md:text-base text-muted-foreground">
                  {stat?.suffix}
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;